import { styled } from '@mui/system'
import { PreOrderDescription, TypographyStyled } from './buttons-action.styled'

const shouldForwardProp = (prop) => !['show'].includes(prop)

const Root = styled('div', { shouldForwardProp })`
	background: ${({ theme }) => theme.palette.white.main};
	bottom: 0px;
	display: block;
	opacity: ${({ show }) => (show ? '1' : '0')};
	transform: ${({ show }) => (show ? 'translateY(0)' : 'translateY(100%)')};
	left: 0px;
	position: fixed;
	z-index: 99;
	transition: all 0.2s ease-out;
	overflow-y: auto;
	border: 1px solid var(--color-primary);
	width: calc(100% - 8px);
	left: 4px;
	bottom: 4px;

	${({ theme }) => theme.breakpoints.up('sm')} {
		border: none;
		border-top: 1px solid var(--color-primary);
		width: 100%;
		left: 0;
		bottom: 0;
	}

	button {
		margin: 0;
	}
	${PreOrderDescription} {
		display: none;
	}
	${TypographyStyled} {
		padding: ${({ theme }) => theme.spacing(0, 3, 1)};
	}
`

export { Root }
